/* eslint-disable node/no-unsupported-features/es-syntax */
import { AUTHENTICATION_ROUTE_NAMES } from "@/shared";
export const AUTHENTICATION_ROUTES = [
    {
        name: AUTHENTICATION_ROUTE_NAMES.PAGE,
        path: "/auth",
        component: () => import("../ui/AuthenticationPage.vue"),
        children: [
            {
                name: AUTHENTICATION_ROUTE_NAMES.LOGIN,
                path: "login",
                meta: {
                    title: "words.authorization",
                },
                component: () => import("../ui/LoginPage.vue"),
            },
            {
                name: AUTHENTICATION_ROUTE_NAMES.REGISTRATION,
                path: "registration",
                meta: {
                    title: "words.registration_link",
                },
                component: () => import("../ui/RegistrationPage.vue"),
            },
            {
                name: AUTHENTICATION_ROUTE_NAMES.WAIT_MAIL,
                path: "registration/confirm",
                meta: {
                    title: "words.email_confirmation",
                },
                component: () => import("../ui/MailConfirmPage.vue"),
            },
            {
                name: AUTHENTICATION_ROUTE_NAMES.CONFIRM_MAIL,
                // Ссылка из письма ведёт на короткий адрес вне /auth
                path: "/confirm",
                meta: {
                    title: "words.email_confirmation",
                    // Страницу открывают до входа. Публичность обязательна ещё и
                    // потому, что общий guard очищает query у адресов с ?token —
                    // вместе с токеном подтверждения
                    public: true,
                },
                component: () => import("../ui/ConfirmMailPage.vue"),
            },
            {
                name: AUTHENTICATION_ROUTE_NAMES.CONFIRM_REGISTRATION,
                path: "contact/check/:guid",
                meta: {
                    title: "words.email_check",
                },
                props: true,
                component: () => import("../ui/ConfirmRegistration.vue"),
            },
            {
                name: AUTHENTICATION_ROUTE_NAMES.RESTORE,
                path: "restore",
                meta: {
                    title: "words.password_recovery",
                },
                component: () => import("../ui/RestorePassword.vue"),
                children: [
                    {
                        name: AUTHENTICATION_ROUTE_NAMES.RESTORE_ENTER_MAIL,
                        path: "",
                        component: () => import("../ui/RestoreEnterMail.vue"),
                    },
                    // {
                    //     name: AUTHENTICATION_ROUTE_NAMES.RESTORE_CONFIRM_MAIL,
                    //     path: ":guid",
                    //     props: true,
                    //     component: () => import("../ui/RestoreConfirmMail.vue"),
                    // },
                    {
                        name: AUTHENTICATION_ROUTE_NAMES.RESTORE_CHANGE_PASSWORD,
                        path: ":guid",
                        props: true,
                        component: () =>
                            import("../ui/RestoreChangePassword.vue"),
                    },
                ],
            },
        ],
    },
];

/* eslint-disable node/no-unsupported-features/es-syntax */
// import { useI18n } from "vue-i18n";

// import { AUTHENTICATION_ROUTE_NAMES } from "@/shared";

// const { t } = useI18n();

// export const AUTHENTICATION_ROUTES = [
//     {
//         name: AUTHENTICATION_ROUTE_NAMES.PAGE,
//         path: "/auth",
//         component: () => import("../ui/AuthenticationPage.vue"),
//         children: [
//             {
//                 name: AUTHENTICATION_ROUTE_NAMES.LOGIN,
//                 path: "login",
//                 meta: {
//                     title: t("words.authorization"),
//                 },
//                 component: () => import("../ui/LoginPage.vue"),
//             },
//             {
//                 name: AUTHENTICATION_ROUTE_NAMES.REGISTRATION,
//                 path: "registration",
//                 meta: {
//                     title: t("words.registration_link"),
//                 },
//                 component: () => import("../ui/RegistrationPage.vue"),
//             },
//             {
//                 name: AUTHENTICATION_ROUTE_NAMES.WAIT_MAIL,
//                 path: "registration/confirm",
//                 meta: {
//                     title: t("words.email_confirmation"),
//                 },
//                 component: () => import("../ui/MailConfirmPage.vue"),
//             },
//             {
//                 name: AUTHENTICATION_ROUTE_NAMES.CONFIRM_REGISTRATION,
//                 path: "contact/check/:guid",
//                 meta: {
//                     title: t("words.email_check"),
//                 },
//                 props: true,
//                 component: () => import("../ui/ConfirmRegistration.vue"),
//             },
//             {
//                 name: AUTHENTICATION_ROUTE_NAMES.RESTORE,
//                 path: "restore",
//                 meta: {
//                     title: t("words.password_recovery"),
//                 },
//                 component: () => import("../ui/RestorePassword.vue"),
//                 children: [
//                     {
//                         name: AUTHENTICATION_ROUTE_NAMES.RESTORE_ENTER_MAIL,
//                         path: "",
//                         component: () => import("../ui/RestoreEnterMail.vue"),
//                     },
//                     // {
//                     //     name: AUTHENTICATION_ROUTE_NAMES.RESTORE_CONFIRM_MAIL,
//                     //     path: ":guid",
//                     //     props: true,
//                     //     component: () => import("../ui/RestoreConfirmMail.vue"),
//                     // },
//                     {
//                         name: AUTHENTICATION_ROUTE_NAMES.RESTORE_CHANGE_PASSWORD,
//                         path: ":guid",
//                         props: true,
//                         component: () =>
//                             import("../ui/RestoreChangePassword.vue"),
//                     },
//                 ],
//             },
//         ],
//     },
// ];
